import { AdgroupConfig } from '@tt4b/ttam-enums';
import { computed, Ref } from '@vue/composition-api';

export function useSwitchPropsDisabled(props: { adgroupConfig: Ref<AdgroupConfig> }) {
  const { adgroupConfig } = props;

  return {
    disabled: computed(() => Boolean(adgroupConfig.value.disableTiktokOnly)),
  };
}
